import React from "react";
import PropTypes from "prop-types";

import styles from "./NewsletterPromoImage.css";

export default function NewsletterPromoImage({ src }) {
  return (
    <div className={styles.root} style={{ backgroundImage: `url(${src})` }} />
  );
}

NewsletterPromoImage.propTypes = {
  src: PropTypes.string.isRequired,
};
